import { ScopeSection } from '@app/features/scope-overview/model/scope-section'
import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { User } from '@core/model/user.model'
import { Type } from 'class-transformer'

export enum FeeAmountType {
  MONETARY = 'MONETARY',
  PERCENTAGE = 'PERCENTAGE',
}

export class FeeItem {
  amount: number
  amountType: FeeAmountType
  @Type(() => User) createdBy: User
  @Type(() => Date) createdTs: Date
  description: string
  id: number
  name: string
  @Type(() => User) updatedBy: User
  @Type(() => Date) updatedTs: Date
  price?: number
  currencyUnit?: string
  baseFeeId?: number
  baseFee?: FeeItem
}

export class FeeItemInstance {
  id: number
  @Type(() => FeeItem) feeItem: FeeItem
  scopeSection?: ScopeSection
  deliverable?: Deliverable
  component?: ScopeComponent
  price?: number
  currencyUnit?: string
  isAdded?: boolean
  isRemoved?: boolean
}
